import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import VerifyEmailErrorMessage from './verify-email-error-message/verify-email-error-message.component';
import VerifyEmailHeader from './verify-email-header/verify-email-header.component';
import VerifyEmailSuccessMessage from './verify-email-success-message/verify-email-success-message.component';
import * as S from './verify-email.styles';

const VerifyEmail = ({ loading, success, error, verifyEmailRequest }) => {
  const { t } = useTranslation();

  return (
    <S.Container data-testid="VerifyEmail.Container">
      <S.ContentContainer elevation={2}>
        {!success && !error && (
          <VerifyEmailHeader title={t('verifyEmailGated.title')} />
        )}
        {success && <VerifyEmailHeader title={t('verifyEmail.header')} />}
        {error && (
          <VerifyEmailHeader title={t('verifyEmailGated.errorTitle')} />
        )}
        <S.ContentBody>
          {!success && !error && (
            <Stack spacing={1}>
              <Typography>{t('verifyEmailGated.description')}</Typography>
              <Button
                variant="contained"
                onClick={verifyEmailRequest}
                disabled={loading}
                data-testid="VerifyEmail.Button"
              >
                {t('verifyEmailGated.button.label')}
              </Button>
            </Stack>
          )}
          {success && <VerifyEmailSuccessMessage />}
          {error && <VerifyEmailErrorMessage />}
        </S.ContentBody>
      </S.ContentContainer>
    </S.Container>
  );
};

export default VerifyEmail;
